// react-big-calendar renders a handful of its own built-in strings (toolbar view names,
// "Today", the Agenda table headers, the "+N more" month-view overflow link) that are never
// passed through our own components — they come from the `messages` prop merged over RBC's
// English defaults (see react-big-calendar/lib/utils/messages.js). Without this, they render
// in English regardless of the active locale.
export const getCalendarMessages = (t) => ({
  agenda: t('calendar:toolbar.agenda'),
  allDay: t('calendar:messages.allDay'),
  date: t('calendar:messages.date'),
  day: t('calendar:toolbar.day'),
  event: t('calendar:messages.event'),
  month: t('calendar:toolbar.month'),
  noEventsInRange: t('calendar:messages.noEventsInRange'),
  showMore: (total) => t('calendar:messages.showMore', { count: total }),
  time: t('calendar:messages.time'),
  today: t('calendar:toolbar.today'),
  week: t('calendar:toolbar.week'),
})
